import script from "./addDeliver.vue?vue&type=script&lang=ts&setup=true"
export * from "./addDeliver.vue?vue&type=script&lang=ts&setup=true"

import "./addDeliver.vue?vue&type=style&index=0&id=0b7f1564&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b7f1564"]])

export default __exports__